/**
 * Опции `loadable` для компонентов без SSR. Подключаются только через spread: `{ ...LOADABLE_NO_SSR }`.
 *
 * `@swc/plugin-loadable-components` (>= 11.10) не трансформирует вызовы с литералом `ssr: false`,
 * а `@loadable/component` на сервере требует трансформацию и для них:
 * падает с `SSR requires @loadable/babel-plugin` раньше, чем проверяет `ssr`.
 * Через spread плагин не может вычислить `ssr` и трансформирует вызов.
 * Литерал запрещён правилом `loadable/no-inline-ssr-false` (tools/oxlint/loadable-plugin.mjs).
 */
export const LOADABLE_NO_SSR = { ssr: false } as const;
